import { createFileRoute } from "@tanstack/react-router";
import { InboxPage } from "@/features/notifications/InboxPage";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/inbox")({
  beforeLoad: requireAuth,
  component: InboxPage,
});
